import {
  Box,
  Button,
  Center,
  Group,
  Image,
  Paper,
  Stack,
  Text
} from "@mantine/core";
import { TbCircleFilled } from "react-icons/tb";

import mosaicLogo from "modules/core/assets/img/mosaic.png";

type EmptyViewProps = {
  title?: string;
  description?: string;
  context?: string[];
  suggestedMessages?: string[];
  setMessage: (message: string) => void;
};
const EmptyView = (props: EmptyViewProps) => {
  const {
    title = "Ask Mosaic",
    description = "Ask Mosaic anything about your project",
    context,
    suggestedMessages,
    setMessage
  } = props;

  return (
    <Center h="100%">
      <Stack justify="center" align="center" ta="center" px="xl" w="100%">
        <Image src={mosaicLogo} w={50} h={50} />

        <Box w="100%">
          <Text size="sm" fw={700} c="violet" mb="xs">
            {title}
          </Text>

          <Text size="sm" c="gray.6" maw="70%" ta="center" mx="auto">
            {description}
          </Text>
        </Box>

        {context ? (
          <Paper p="md" bg="gray.0" w="100%" ta="left">
            <Text size="xs" c="gray.6" mb="xs">
              In Context
            </Text>

            <Group gap="md" wrap="wrap">
              {context.map(item => (
                <Group key={item} gap={6}>
                  <TbCircleFilled
                    color="var(--mantine-color-violet-6)"
                    size={7}
                  />

                  <Text fz="xs" c="gray.7" tt="capitalize" truncate>
                    {item}
                  </Text>
                </Group>
              ))}
            </Group>
          </Paper>
        ) : null}

        {suggestedMessages ? (
          <Stack gap="xs" flex={1}>
            {suggestedMessages.map(message => (
              <Button
                key={message}
                variant="outline"
                size="xs"
                color="gray"
                c="dark"
                onClick={() => setMessage(message)}
              >
                {message}
              </Button>
            ))}
          </Stack>
        ) : null}
      </Stack>
    </Center>
  );
};

export default EmptyView;
